import React from 'react';
import { Switch, Route } from 'react-router-dom';
import UserManagement from './userManagement';
import AddOrEditUser from './AddOrEdit';
import UserDetails from './details/details';

const Users = props => {
  return (
    <Switch>
      <Route path="/users/details" exact render={routeProps => <UserDetails {...routeProps} />} />
      <Route path="/users/add" exact render={routeProps => <AddOrEditUser {...routeProps} />} />
      <Route path="/users/edit" exact render={routeProps => <AddOrEditUser {...routeProps} />} />
      <Route path="/" component={UserManagement} />
    </Switch>
  );
};

export default Users;
